import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

/**
 * RTK Query API for fetching the catalog of UI strings from the backend.
 *
 * GET /api/v1/messages returns a flat dict { UI_KEY: "display text", ... }.
 * Fetched once on app load (App.jsx kicks off the query) and cached in Redux
 * for the lifetime of the session. Consumers read via `notify` (which calls
 * `store.getState()` directly) or via the auto-generated React hook.
 */
export const messagesApi = createApi({
  reducerPath: "messagesApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getUiMessages: builder.query({
      query: () => ({ url: "/messages/", method: "GET" }),
      // Strings are immutable for the session — never invalidate.
      keepUnusedDataFor: 24 * 3600,
    }),
  }),
});

export const { useGetUiMessagesQuery } = messagesApi;
